import React, {useEffect} from 'react';
import {MessageSquare} from 'lucide-react';
import TranscriptionItem from './TranscriptionItem';

const TranscriptionsContainer = ({
  transcriptions,
  transcriptionsContainerRef,
  transcriptionsEndRef,
  isCallConnected,
  isMuted
}) => {
  useEffect(() => {
    if (transcriptionsEndRef.current) {
      transcriptionsEndRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  }, [transcriptions, transcriptionsEndRef]);

  return (
    <div
      ref={transcriptionsContainerRef}
      className="flex-1 overflow-y-auto px-3 sm:px-4 md:px-6 py-3 sm:py-4 space-y-2 scrollbar-thin"
      style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255, 107, 53, 0.03), transparent 50%)',
      }}
    >
      {transcriptions.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-center px-4">
          <MessageSquare className="w-12 h-12 sm:w-16 sm:h-16 text-zinc-700 mb-3 sm:mb-4"/>
          <p className="text-zinc-400 text-base sm:text-lg">No conversation yet</p>
          <p className="text-zinc-500 text-xs sm:text-sm mt-2 max-w-xs">
            {!isCallConnected
              ? 'Start a call to begin transcribing'
              : isMuted
                ? 'Unmute to start speaking'
                : 'Start speaking to see transcriptions'}
          </p>
        </div>
      ) : (
        <>
        {transcriptions
          .filter(({ transcript }) => transcript?.trim())
          .map(t => (
            <TranscriptionItem key={t.id} transcription={t} />
          ))}

          <div ref={transcriptionsEndRef}/>
        </>
      )}
    </div>
  );
};

export default TranscriptionsContainer;
